import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { ChecklistInstanceEditor } from './checklist-instance-editor';
import { useChecklistById } from '../context/checklist-context';

interface ChecklistEditDialogProps {
  open: boolean;
  checklistId: string | null;
  onOpenChange: (open: boolean) => void;
  onSave: (updatedChecklist: any) => void;
}

export const ChecklistEditDialog: React.FC<ChecklistEditDialogProps> = ({ open, checklistId, onOpenChange, onSave }) => {
  if (!checklistId) return null;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-6xl! shadow-none border-none max-h-[90vh] overflow-y-auto p-0 [&::-webkit-scrollbar]:w-[3px] [&::-webkit-scrollbar]:bg-transparent [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-muted-foreground/10 [&::-webkit-scrollbar-thumb]:transition-colors [&::-webkit-scrollbar-thumb:hover]:bg-muted-foreground/20"
        style={{ scrollbarWidth: 'thin' }}
      >
        {/* <DialogHeader>
          <DialogTitle>Edit Checklist</DialogTitle>
        </DialogHeader> */}
        <ChecklistInstanceEditor
          checklistId={checklistId}
          onSave={onSave}
          onCancel={() => onOpenChange(false)}
        />
      </DialogContent>
    </Dialog>
  );
};
